// extracted by mini-css-extract-plugin
export default {"headerRow":"SavedViews-module__headerRow--JHWUB","savedViewsList":"SavedViews-module__savedViewsList--CZ1Yt"};